import { FC } from 'react'
import { LandingFeature } from './LandingFeature'
import './LandingFeatures.scss'
import SvgFormats from '../components/icons/Formats'
import SvgCompass from '../components/icons/Compass'
import SvgPlayback from '../components/icons/Playback'
import SvgPerformance from '../components/icons/Performance'
import SvgConvert from '../components/icons/Convert'
import SvgUbuntu from '../components/icons/Ubuntu'

export const LandingFeatures: FC = () => {
  return (
    <div className="LandingFeatures">
      <h2 className="title">We are trying to create the most convenient audio cutting tool</h2>

      <ul className="features">
        <LandingFeature
          icon={<SvgFormats />}
          title="Support for most formats"
          description="We have managed to implement support for most audio formats: MP3, WAV, OGG, FLAC, MP4, AAC, AIFF, WEBM and many others."
        />

        <LandingFeature
          icon={<SvgCompass />}
          title="Convenient navigation"
          description="Our main focus is the convenience of the interface and navigation through an audio recording, so that you can easily find a right fragment to trim."
        />

        <LandingFeature
          icon={<SvgPlayback />}
          title="Immediate playback"
          description="You can immediately listen to the cut record without the need to first download it to your computer and it works really fast."
        />

        <LandingFeature
          icon={<SvgPerformance />}
          title="Focus on performance"
          description="To make it pleasant to use our software, performance is one challenge that we take on. Our goal is to make you think that the processing of audio is an easy task."
        />

        <LandingFeature
          icon={<SvgConvert />}
          title="Convert into different formats"
          description="Support for various formats makes it possible to use our software as an audio converter. You can simply open a file in one format and immediately download in the necessary one."
        />

        <LandingFeature
          icon={<SvgUbuntu />}
          title="Cross-platform online tool"
          description="As an online solution, our software can be used on any platform or operating system: Windows, MacOS or Linux. No need to download and install it."
        />
      </ul>
    </div>
  )
}
